import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_button = _resolveComponent("toggle-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (+(_ctx.activeUserId ?? 0) == 101)
      ? (_openBlock(), _createBlock(_component_toggle_button, {
          key: 0,
          value: _ctx.toggleValue,
          height: 25,
          width: 60,
          checkedText: "On",
          uncheckedText: "Off",
          checkedBg: " #0054a6",
          uncheckedBg: "lightgrey",
          onClick: _ctx.onChange
        }, null, 8, ["value", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}